import React from 'react'

export default function Navbar({setCategory,setCountry,setSearch,setSearchTemp,searchTemp,setMode,mode}) {
  return (
      <nav className={`navbar navbar-expand-lg mb-1 ${mode==="light"?"bg-dark-subtle":"bg-dark text-white"} `} data-bs-theme={mode==="light"?"light":"dark"} style={{position:"fixed", top:"0",width:"100vw",zIndex:"12"}}>
    <div className="container-fluid">
      <a className="navbar-brand" href="/">
      <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="Dhakar News logo with brand initials D and N" width="30" height="24" className="d-inline-block align-middle-top mx-2"/>Dhakar News</a>
      <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span className="navbar-toggler-icon"></span>
      </button>
      <div className="collapse navbar-collapse" id="navbarSupportedContent">
        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
          <li className="nav-item">
            <a className="nav-link active" aria-current="page" href="/" onClick={()=>{ setCategory(""); setCountry(""); setSearch(""); setSearchTemp("")}}>Home</a>
          </li>
          <li className="nav-item dropdown">
          <a className="nav-link dropdown-toggle" href="/" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            Catagories
          </a>
          <ul className="dropdown-menu">
            <li><button className="dropdown-item" onClick={()=>{ setCategory("")}}>General</button></li>
            <li><button className="dropdown-item" onClick={()=>{ setCategory("business")}}>Buisness</button></li>
            <li><button className="dropdown-item" onClick={()=>{ setCategory("entertainment")}}>Entertainment</button></li>
            <li><button className="dropdown-item" onClick={()=>{ setCategory("health")}}>Health</button></li>
            <li><button className="dropdown-item" onClick={()=>{ setCategory("science")}}>Science</button></li>
            <li><button className="dropdown-item" onClick={()=>{ setCategory("sports")}}>Sports</button></li>
            <li><button className="dropdown-item" onClick={()=>{ setCategory("technology")}}>Technology</button></li>
          </ul>
        </li>
        <li className="nav-item dropdown">
          <a className="nav-link dropdown-toggle" href="/" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            Country
          </a>
          <ul className="dropdown-menu">
            <li><button className="dropdown-item" onClick={()=>{ setCountry("")}}>General</button></li>
            <li><button className="dropdown-item" onClick={()=>{ setCountry("us")}}>United States</button></li>
            <li><button className="dropdown-item" onClick={()=>{ setCountry("gb")}}>United Kingdom</button></li>
            <li><button className="dropdown-item" onClick={()=>{ setCountry("ca")}}>Canada</button></li>
            <li><button className="dropdown-item" onClick={()=>{ setCountry("au")}}>Australia</button></li>
            <li><button className="dropdown-item" onClick={()=>{ setCountry("in")}}>India</button></li>
            <li><button className="dropdown-item" onClick={()=>{ setCountry("de")}}>Germany</button></li>
          </ul>
        </li>
        </ul>
          <form className="d-flex" role="search">
            <input className="form-control me-2" type="search" placeholder="Search News...." aria-label="Search" onChange={(e) => setSearchTemp(e.target.value)}/>
            <button className="btn btn-outline-success" type="button" onClick={()=> setSearch(searchTemp)}>Search</button>
          </form>
          <div className="form-check form-switch mx-3">
          <input className="form-check-input" type="checkbox" role="switch" id="switchCheckDefault" onChange={()=> setMode(mode === "light" ? "dark" : "light")}/>
          <label className="form-check-label" htmlFor="switchCheckDefault">Dark Mode</label>
        </div>
        </div>
      </div>
    </nav>
  )
}
